module.exports = __webpack_public_path__ + "static/media/Gist.70ea5129.svg";